import { render, staticRenderFns } from "./vExportLabel.vue?vue&type=template&id=4c96ccc3&scoped=true"
import script from "./vExportLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./vExportLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vExportLabel.vue?vue&type=style&index=0&id=4c96ccc3&prod&scoped=true&lang=css"
import style1 from "./vExportLabel.vue?vue&type=style&index=1&id=4c96ccc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96ccc3",
  null
  
)

export default component.exports